var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10697",
    "data-name": "Group 10697",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3035",
    "data-name": "Rectangle 3035",
    width: 24,
    height: 21,
    fill: "#313a41",
    stroke: "#313a41",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10686",
    "data-name": "Group 10686",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28441",
    "data-name": "Path 28441",
    d: "M22,7.339,21.86,7a1.5,1.5,0,0,0,0-3H20.631l-1.12-2.792A2.515,2.515,0,0,0,17.369,0H6.631A2.537,2.537,0,0,0,4.448,1.292L3.36,4H2.12a1.5,1.5,0,0,0,0,3L2,7.339A3.5,3.5,0,0,0,0,10.5v5a2.493,2.493,0,0,0,2,2.448V19.5A1.5,1.5,0,0,0,3.5,21h1A1.5,1.5,0,0,0,6,19.5V18H18v1.5A1.5,1.5,0,0,0,19.5,21h1A1.5,1.5,0,0,0,22,19.5V17.948A2.493,2.493,0,0,0,24,15.5v-5a3.5,3.5,0,0,0-2-3.161M21.88,5a.5.5,0,0,1,.427.765A.506.506,0,0,1,21.88,6h-.448l-.4-1ZM3.36,6.7l.8-2,1.177-3A1.521,1.521,0,0,1,6.631,1H17.369a1.508,1.508,0,0,1,1.251.661L20.76,7H3.24ZM2.12,6a.5.5,0,1,1,0-1H3L2.6,6ZM5,19.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V18H5ZM7.609,17l.579-3h7.64l.584,3ZM21,19.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V18h2Zm2-4A1.5,1.5,0,0,1,21.5,17H17.412l-.693-3.588A.5.5,0,0,0,16.229,13H7.771a.5.5,0,0,0-.489.412L6.588,17H2.5A1.5,1.5,0,0,1,1,15.5v-5A2.5,2.5,0,0,1,3.5,8h17A2.5,2.5,0,0,1,23,10.5ZM6.5,9h-3A1.5,1.5,0,0,0,2,10.5v1a.5.5,0,0,0,.5.5h4a.5.5,0,0,0,.5-.5v-2A.5.5,0,0,0,6.5,9M6,11H3v-.5a.5.5,0,0,1,.5-.5H6ZM3.5,13A1.5,1.5,0,1,0,5,14.5,1.5,1.5,0,0,0,3.5,13m0,2a.5.5,0,1,1,.5-.5.5.5,0,0,1-.5.5m11-5h-4a.5.5,0,0,0,0,1h4a.5.5,0,0,0,0-1m6-1h-3a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h4a.5.5,0,0,0,.5-.5v-1A1.5,1.5,0,0,0,20.5,9m.5,2H18V10h2.5a.5.5,0,0,1,.5.5Zm-.5,2A1.5,1.5,0,1,0,22,14.5,1.5,1.5,0,0,0,20.5,13m0,2a.5.5,0,1,1,.5-.5.5.5,0,0,1-.5.5",
    fill: "#313a41",
    stroke: "#313a41",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeIcon);
export default __webpack_public_path__ + "static/media/make_icon.f3fdffe500ba1c9961abfbf493793c47.svg";
export { ForwardRef as ReactComponent };